interface IProps {
  isClicked: boolean;
}

export const AlphaIcon = ({ isClicked }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <g clipPath="url(#clip0_1516_4535)">
        <path
          d="M22.4099 6.9902H15.3299L18.8699 3.4502L22.4099 6.9902ZM15.3749 29.0552H22.3649L18.8699 32.5502L15.3749 29.0552ZM9.1499 9.4052L2.3999 26.5952H5.1599L6.5399 22.9202H14.2049L15.5849 26.5952H18.3449L11.6099 9.4052H9.1499ZM7.4549 20.4602L10.3649 12.6902L13.2749 20.4602H7.4549ZM23.5949 24.2102H32.7749V26.5952H19.9799V24.6602L28.8599 11.8202H20.0399V9.4202H32.4899V11.3102L23.5949 24.2102Z"
          fill={isClicked ? "#fff" : "#004A80"}
        />
      </g>
      <defs>
        <clipPath id="clip0_1516_4535">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
